import { render, staticRenderFns } from "./FACE.vue?vue&type=template&id=703a95ef"
import script from "./FACE.vue?vue&type=script&lang=js"
export * from "./FACE.vue?vue&type=script&lang=js"
import style0 from "./FACE.vue?vue&type=style&index=0&id=703a95ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports